import type { GraphPathLookupParameters } from './GraphPathLookupParameters';
import type { GraphTopologyParameters } from './GraphTopologyParameters';

export type GraphParameters =
  | GraphPathLookupParameters
  | GraphTopologyParameters;

export function isPathLookupRequestParameters(
  params?: GraphParameters | null,
): params is GraphPathLookupParameters {
  return params?.type === 'pathLookup';
}

export function isTopologyRequestParameters(
  params?: GraphParameters | null,
): params is GraphTopologyParameters {
  return params?.type === 'topology';
}
